import Vue from "vue";
import env from "@/configuration/env";

const mixin = function(Vue) {
  Vue.mixin({
    created() {
      this.$env = env;
    },
  });
};

Vue.use(mixin);
